export default "<label for=\"\" [attr.class]=\"defaultCss\">\n    {{text}}\n</label>"